// format number with commas
export default function formatNumberWithCommas(number: number): string {
	return number.toLocaleString();
}
